// src/utils/langStorage.ts
import {Lang} from '@context/CompetitionImamrezaContext';

const LANG_STORAGE_KEY = 'imamreza-lang';

export const saveLang = (lang: Lang) => {
	localStorage.setItem(LANG_STORAGE_KEY, lang);
};

export const loadLang = (): Lang => {
	return (localStorage.getItem(LANG_STORAGE_KEY) as Lang) || 'fa';
};
